import { materialSymbols } from "../../../../../shared/constants/material-symbols";
import { IVoteOptionWithName } from "../ballot-base/ballot-vote-dto";


export enum iecFinaliseVoteId {
  inFavourOf = "IN_FAVOUR_OF",
  against = "AGAINST",
  abstain = "ABSTAIN",
  noResponse = "NO_RESPONSE"
}


export const iecFinaliseVoteOption: { [key: string]: IVoteOptionWithName } = {
  "IN_FAVOUR_OF": {color: '#1A936F', icon: materialSymbols.thumbUp, text: 'In Favour Of', name:'IN_FAVOUR_OF', id: "in-favour-of"},
  "AGAINST": {color: '#CE1114', icon: materialSymbols.thumbDown, text: 'Against', name:'AGAINST', id: "against"},
  "ABSTAIN": {color: '#007AC9', icon: materialSymbols.block, text: 'Abstain', name:'ABSTAIN', id: "abstain"},
  "NO_RESPONSE": {color: '#FFB500', icon: materialSymbols.doNotDisturb, text: 'No Response', name:'NO_RESPONSE', id: "no-response"}
}


export interface IFinaliseIecBallotRequest {
  ballotId: string
  FinalisedBy: string
  ResolutionName: string
}
